const errorKey = 'channel.edit.fixed_forwarded_ip_v1013.invalid';

export function normalizeFixedForwardedIPV1013(input) {
  if (typeof input !== 'string' || /[\r\n]/.test(input)) {
    throw new Error(errorKey);
  }
  const value = input.trim();
  if (value.includes(':')) {
    if (!/^[0-9a-f:.]+$/i.test(value)) throw new Error(errorKey);
    try {
      return new URL(`http://[${value}]/`).hostname.slice(1, -1);
    } catch {
      throw new Error(errorKey);
    }
  }
  const parts = value.split('.');
  if (
    parts.length !== 4 ||
    parts.some((part) => !/^(0|[1-9]\d{0,2})$/.test(part) || Number(part) > 255)
  ) {
    throw new Error(errorKey);
  }
  return parts.join('.');
}

export function supportsFixedForwardedIPV1013(type) {
  return ![18, 33].includes(Number(type));
}

export function fixedForwardedIPErrorV1013(config = {}, type) {
  if (!config.fixed_forwarded_ip_enabled_v1013) return '';
  if (!supportsFixedForwardedIPV1013(type))
    return 'channel.edit.fixed_forwarded_ip_v1013.unsupported';
  if (config.edge_proxy)
    return 'channel.edit.fixed_forwarded_ip_v1013.edge_conflict';
  try {
    normalizeFixedForwardedIPV1013(config.fixed_forwarded_ip_v1013 || '');
    return '';
  } catch (error) {
    return error.message;
  }
}

export function buildFixedForwardedIPV1013(config = {}, type) {
  const error = fixedForwardedIPErrorV1013(config, type);
  if (error) throw new Error(error);
  const enabled = config.fixed_forwarded_ip_enabled_v1013 === true;
  let value = '';
  if (config.fixed_forwarded_ip_v1013) {
    try {
      value = normalizeFixedForwardedIPV1013(config.fixed_forwarded_ip_v1013);
    } catch (error) {
      if (enabled) throw error;
    }
  }
  return {
    ...config,
    fixed_forwarded_ip_enabled_v1013: enabled,
    fixed_forwarded_ip_v1013: value,
  };
}
